import { render, staticRenderFns } from "./PetFood.vue?vue&type=template&id=38b916f4&scoped=true"
import script from "./PetFood.vue?vue&type=script&lang=js"
export * from "./PetFood.vue?vue&type=script&lang=js"
import style0 from "./PetFood.vue?vue&type=style&index=0&id=38b916f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b916f4",
  null
  
)

export default component.exports